export default "__VITE_ASSET__DmdMBUHv__"